var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewzealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 600,
    width: 1200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Canton"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 600,0 L 600,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Diagonals"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pentagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm",
    transform: "translate(0,-0.324925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,0.5 L 1,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,-0.5 L 1,0 z",
    transform: "rotate(-36,1,0)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0) scale(-1,1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#012169",
    x: 0,
    y: 0,
    width: 1200,
    height: 600
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_the_United_Kingdom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Saint_Andrews_Cross",
    stroke: "#FFF",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Saint_Patricks_Cross",
    stroke: "#C8102E",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 40,
    clipPath: "url(#Diagonals)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Saint_Georges_Cross"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 100,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Southern_Cross"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gamma_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#FFF",
    transform: "translate(900,120) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#C8102E",
    transform: "translate(900,120) scale(30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82,900,240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#FFF",
    transform: "translate(900,120) rotate(-82) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#C8102E",
    transform: "translate(900,120) rotate(-82) scale(25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Beta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#FFF",
    transform: "translate(900,380) rotate(-82) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#C8102E",
    transform: "translate(900,380) rotate(-82) scale(30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Alpha_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#FFF",
    transform: "translate(900,480) scale(50.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#C8102E",
    transform: "translate(900,480) scale(35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewzealand);
export default __webpack_public_path__ + "static/media/newzealand.0fb39b020eeda014e44984a5b409b332.svg";
export { ForwardRef as ReactComponent };